import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Magento_CustomAttributeManagement implements user-defined attributes management which provides ability to manage attributes of customers and their address.
Admin user can manage attributes on UI level without assistance of programmer.
Admin user can create new, modify, and remove attributes, control attributes properties and visibility on frontend.
User defined attributes are attributes which are created by admin user and not available out of box.
This attributes can be deleted from the system after their creation.
System attributes are attributes which cannot be deleted from the system in usual way and admin user can edit only their label.
Hidden attribute is an attribute which is hidden from the user on back-end and on front-end.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 100.4.7.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      